import ajax from '../assets/js/ajax'
const state = {
  curUser: null
}
const actions = {
  saveBaseInfo (ctx, params) {
    return ajax.post('zhaopin/b/company/savebaseinfo.json', params)
      .then(() => ctx.dispatch('initUser'))
  },
  submitAudit (ctx, params) {
    return ajax.post('/zhaopin/b/company/submitaudit.json', params)
      .then(() => ctx.dispatch('initUser'))
  }
}
const mutations = {

}
export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/center.js